module.exports = __webpack_public_path__ + "static/media/8900_Front2.5dda256b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Front2.jpg
// module id = 64
// module chunks = 0